export class PTOTimeEntryMeta {}
